import { useContext, useMemo } from 'react';

import { UserContext } from 'src/containers/user';

export function useGetSequenceQueryFilters() {
  const { userProfile } = useContext(UserContext);
  return useMemo(() => ({ userId: userProfile?.id }), [userProfile?.id]);
}
